import { createSlice } from '@reduxjs/toolkit';
import { fetchStatuses } from '../../../../constants/fetchStatuses';
import { fetchOnboardingEmployees } from './onboardingEmployee.actions';
import { OnboardingEmployeeState } from './onboardingEmployee.types';

const initialState: OnboardingEmployeeState = {
  onboardingEmployees: [],
  totalOnboardingEmployees: 0,
  fetchOnboardingEmployeesStatus: fetchStatuses.idle,
  error: null,
};

const onboardingEmployeeSlice = createSlice({
  name: 'onboardingEmployee',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // === FETCH ONBOARDING EMPLOYEES ===
    builder.addCase(fetchOnboardingEmployees.pending, (state) => {
      state.error = null;
      state.fetchOnboardingEmployeesStatus = fetchStatuses.pending;
    });
    builder.addCase(fetchOnboardingEmployees.fulfilled, (state, action) => {
      state.fetchOnboardingEmployeesStatus = fetchStatuses.success;
      if (action.payload.data?.data) {
        state.onboardingEmployees = action.payload.data.data;
        state.totalOnboardingEmployees = action.payload.data.total || 0;
      }
    });
    builder.addCase(fetchOnboardingEmployees.rejected, (state, action) => {
      state.fetchOnboardingEmployeesStatus = fetchStatuses.rejected;
      state.error = action.error;
    });
  },
});

export default onboardingEmployeeSlice.reducer;
